import React from 'react';
import { IFeedTab } from './interfaces';
import { ResourceMessageFeed } from '@components/feed/ResourceMessageFeed';

export const FeedTab: React.FC<IFeedTab> = ({
  show,
  slug,
}): JSX.Element | null => {
  if (!show) {
    return null;
  }

  return (
    <ResourceMessageFeed
      resourceType="competition"
      resourceId={slug}
      canPostMessages
    />
  );
};
